module.exports = __webpack_public_path__ + "img/刘春胜.0ebf8263.png";